// core version + modules:
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

export function basicSlideshow(opts = {}) {
  let swiper = null;
  let swiperEl = null;

  return {
    set autoplay(v) {
      if(v) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    },
    set isInView(v) {
      this.autoplay = v;
    },
    init() {
      swiperEl = this.$refs.swiperEl || this.$root;
      swiper = new Swiper(swiperEl, {
        autoplay: {
          delay: 2000,
        },
        autoplayDisableOnInteraction: false,
        loop: false,
        observer: true,
        observeParents: true,
        modules: [EffectFade, Autoplay],
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        speed: 500,
        allowTouchMove: false,
        noSwiping: true,
        fadeEffect: {
          crossFade: true,
        },
      });
    }
  };
}
